import { type ResponseGenerics } from '@dni-types/utilities/response'
import { createRequestHelper } from '@utils/swr'

export type CampaignIsAdminResponse = ResponseGenerics<{ is_admin: boolean }>

const { useRequest } = createRequestHelper<`/campaigns/${string}/admin/is-admin`, CampaignIsAdminResponse, string | null>({
  client: 'fortune',
  key: code => code ? `/campaigns/${code}/admin/is-admin` : null,
  isImmutable: true,
})

export const useApiCampaignIsAdmin = useRequest
